// Mirrors the Happy Hour site's cocktail sections. The three-column layout is
// its featured section (Fall Sips): a fluid, balanced heading and a balanced
// eyebrow. The photo grids (Signature Cocktails, Non-Alcoholic) step from 52px
// to 96px at 1024px and leave their headings unbalanced, as that site does.
.section {
    padding: 64px 0;

    @media (min-width: 1024px) {
        padding: 80px 0;
    }
}

.eyebrow {
    color: var(--hh-lobster);
    font-size: 20px;

    @media (min-width: 1024px) {
        font-size: 28px;
    }
}

.heading {
    font-size: 52px;

    @media (min-width: 1024px) {
        font-size: 96px;
    }
}

.featured {
    .eyebrow {
        text-wrap: balance;
    }

    .heading {
        font-size: clamp(52px, 9.4vw, 96px);
        text-wrap: balance;
    }
}

.headingAfterEyebrow {
    margin-top: 8px;
}

.banner {
    aspect-ratio: 1000 / 466;
    display: block;
    height: auto;
    margin-top: 32px;
    object-fit: cover;
    width: 100%;

    @media (min-width: 1024px) {
        margin-top: 40px;
    }
}

.subheading {
    color: var(--hh-lobster);
    font-size: 22px;
    margin-top: 32px;

    @media (min-width: 1024px) {
        font-size: 32px;
        margin-top: 40px;
    }
}

.items {
    display: grid;
}

.item {
    min-width: 0;
}

.itemPhoto {
    display: block;
    height: auto;
    object-fit: cover;
    width: 100%;
}

.itemCopy {
    line-height: 1.625;
    margin: 0;
}

// Three text columns separated by hairlines from 768px.
.columns {
    gap: 32px;
    margin-top: 24px;

    .itemName {
        font-size: 24px;
    }

    .itemCopy {
        font-size: 15px;
        margin-top: 12px;
    }

    @media (min-width: 768px) {
        gap: 0;
        grid-template-columns: repeat(3, 1fr);

        .item {
            padding: 0 24px;
        }

        .item + .item {
            border-left: 1px solid #000000;
        }
    }

    @media (min-width: 1024px) {
        .itemCopy {
            font-size: 16px;
        }
    }

    @media (min-width: 1280px) {
        .item {
            padding: 0 12px;
        }
    }
}

// Square photos, two across on phones, five across from 1024px.
.gridFive {
    gap: 32px;
    margin-top: 32px;

    .itemPhoto {
        aspect-ratio: 1;
    }

    .itemName {
        font-size: 20px;
        margin-top: 20px;
        text-wrap: balance;
    }

    .itemCopy {
        font-size: 13px;
        margin-top: 8px;
    }

    @media (min-width: 640px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 1024px) {
        gap: 24px;
        grid-template-columns: repeat(5, 1fr);
        margin-top: 48px;

        .itemName {
            font-size: 21px;
        }

        .itemCopy {
            font-size: 14px;
        }
    }
}

// 3:2 photos, two across from 768px.
.gridTwo {
    gap: 32px;
    margin: 32px auto 0;
    max-width: 64rem;

    .itemPhoto {
        aspect-ratio: 3 / 2;
    }

    .itemName {
        font-size: 26px;
        margin-top: 20px;
    }

    .itemCopy {
        font-size: 15px;
        margin-top: 8px;
    }

    @media (min-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 1024px) {
        margin-top: 48px;

        .itemCopy {
            font-size: 16px;
        }
    }
}
